import { useEffect } from "react"

export declare type InputProps = {
    count: []
}


export const ActiveUserChart = ({ count }: InputProps) => {


    return (
        <div className="w-full h-full flex flex-col justify-between items-center">
            <span className=" text-sm text-center">افراد حاضر</span>
            <div className="w-[100px] h-[100px] rounded-full shadow flex justify-center items-center bg-[#f2f2f2]">
                <div className="w-[85px] h-[85px] rounded-full bg-white flex justify-center items-center text-sm">
                    {count} نفر
                </div>
            </div>
            <div></div>
        </div>
    );
}